import serializer from './to_wiki';

export { serializer };
